import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	linkFieldLabel: {
		id: 'custom-sites-extensions.link-cards.config-panel.link.field.label',
		defaultMessage: 'Link',
		description: 'Visible label for link field in the link cards config panel',
	},
	titleFieldLabel: {
		id: 'custom-sites-extensions.link-cards.title.field.label',
		defaultMessage: 'Title',
		description: 'Visible label for title field in the link cards config panel',
	},
	recommendedFieldLabel: {
		id: 'custom-sites-extensions.link-cards.recommended.field.label',
		defaultMessage: '(Recommended)',
		description: 'Visible `recommended` label for the title field in the link cards config panel',
	},
	descriptionFieldLabel: {
		id: 'custom-sites-extensions.link-cards.description.field.label',
		defaultMessage: 'Description',
		description: 'Visible label for description field in the link cards config panel',
	},
});
